import {Row, Space} from "antd";
import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import {AutoGraphRounded, CloseRounded, DeleteForeverRounded} from "@mui/icons-material";
import React from "react";

const BlotterToolbar = ({selectedPoints, chartRef, submitPrompt})=>{
    return (
        <Row justify={'center'} style={{borderBottom: '2px solid #ededed', padding: '10px'}}>
            <Space>
                <ButtonGroup>
                    <Button variant={'outlined'}
                            color={'error'}
                            onClick={()=>chartRef.current.clearAnnotations().clearSelectedPoints()}
                            startIcon={<DeleteForeverRounded/>}
                            size={'small'}
                    >
                        Clear All
                    </Button>
                    {selectedPoints.map((point, index)=>(
                        <Button size={'small'} startIcon={<CloseRounded/>} variant={'outlined'} color={'inherit'} onClose={()=>{}} closable>{point.timestamp}</Button>
                    ))}
                    <Button size={'small'} variant={'contained'} color={'info'}  startIcon={<AutoGraphRounded/>} onClick={submitPrompt}>
                        AI Insights
                    </Button>
                </ButtonGroup>
            </Space>
        </Row>
    )
}

export default BlotterToolbar;